import { COUNTRY_CODE } from "@dw/constants/intl";
import { IAuditBase, IDateOnlyRange, IDateOnlyRangeRequest, IMenuItem } from "./shared";
import { splitByUpperCase } from "@dw/utils";
import { Dayjs } from '@dw/dayjs'

export enum BILLING_FREQUENCY {
  /**
   * Bill once per school term
   */
  TERM = "Term"
}
export const BILLING_FREQUENCY_OPTIONS: IMenuItem[] = Object.values(BILLING_FREQUENCY).map(x => ({
  value: x,
  text: splitByUpperCase(x)
}));

export interface IDanceSchoolTerm {
  termNumber: number;
  termDates: IDateOnlyRange;
}

export interface IDanceSchool extends IAuditBase {
  id: string;
  name: string;
  logoKey: string;
  countryCode: COUNTRY_CODE;
  annualSettings: IDanceSchoolAnnualSettings[];
  xeroConnectionStatus: IDanceSchoolXeroConnectionStatus;
  termsAndConditions: IDanceSchoolTermsAndConditions[];
  billingSettings: IDanceSchoolBillingSettings;
  publicInfo: IDanceSchoolPublicInfo;
}

export interface IDanceSchoolPublicInfo {
  websiteUrl: string;
}

export interface IDanceSchoolBillingSettings {
  /**
   * How many days before the cycle starts should invoices be generated
   */
  daysBeforeCycleStartToGenerateInvoices: number;

  /**
   * Should invoices automatically be approved and sent out when generated
   */
  autoApproveAndSendInvoices: boolean;

  /**
   * How many days before a cycle starts should the invoice be due
   */
  invoicesDueDaysBeforeCycleStarts: number;
}

export interface IDanceSchoolAnnualSettings {
  year: number;
  billingFrequency: BILLING_FREQUENCY;
  termDates: IDateOnlyRange[];
  yearStarted: boolean;
}

export interface IDanceSchoolXeroConnectionStatus {
  connected: boolean;
  connectedSince?: Dayjs;
  xeroTenantName: string;
  xeroTenantId: string;
  xeroSalesAccountCode: string;
}

export interface IDanceSchoolTermsAndConditions {
  fileKey: string;
  fileUploadName: string;
  isActive: boolean;
  createdTimestamp: Dayjs;
}

export interface ICreateDanceSchoolRequest {
  name: string;
  logoKey: string;
  countryCode: COUNTRY_CODE;
  websiteUrl: string;
}

export interface IUpdateDanceSchoolPublicInfoRequest {
  name: string;
  logoKey: string;
  websiteUrl: string;
}

export interface IUpdateDanceSchoolTermsAndConditionsRequest {
  fileKey: string;
}

export interface IUpsertDanceSchoolAnnualSettingsRequest {
  year: number;
  billingFrequency: BILLING_FREQUENCY;
  termDates: IDateOnlyRangeRequest[];
}

export interface IUpdateDanceSchoolXeroSalesAccountCodeRequest {
  xeroSalesAccountCode: string;
}

export interface IUpdateDanceSchoolBillingSettingsRequest {
  daysBeforeCycleStartToGenerateInvoices: number | null;
  autoApproveAndSendInvoices: boolean | null;
  invoicesDueDaysBeforeCycleStarts: number | null;
}